<template>
<div class="chapter">
<div class="inner_page">
<div id="Epub4211-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="PN-I" id="toc_marker-4"><span class="char-style-override-4">THEN WE <br/>TAKE BERLIN</span></p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-5" xml:lang="en-GB">John Lawton</span></p>
<p class="BT-1st-Para para-style-override-3"><img alt="L-1.tif" class="image" height="23" src="images/L-1_fmt.png" width="26"/></p>
<p class="BT-1st-Para para-style-override-1">Atlantic Monthly Press</p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">New York</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epub42113.vue?8c6a51ae